import axios from "axios"
import {
  BASEURL,
  LOGIN,
  LOGIN_WITH_SSO,
  USER_SIGNUP,
  COMPANY_REGISTER,
  FORGOTPWD,
} from "helpers/url_helper"

export const SSOloginApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }

  return axios
    .post(`${BASEURL}${LOGIN_WITH_SSO}`, data, headers)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.response?.data?.message || "An error occurred"
            break
        }
        return { error: message, status: "Error" }
      }
      return err.response?.data || err
    })
}

export const loginApi = data => {
  if (process.env.NODE_ENV === 'development') {
    console.log("🚀 loginApi called with data:", data)
  }
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }
  if (process.env.NODE_ENV === 'development') {
    console.log("🚀 Making API call to:", `${BASEURL}${LOGIN}`)
    console.log("🚀 Request headers:", headers)
    console.log("🚀 Request payload:", data)
  }
  
  const axiosPromise = axios.post(`${BASEURL}${LOGIN}`, data, headers)
  if (process.env.NODE_ENV === 'development') {
    console.log("🚀 Axios promise created:", axiosPromise)
  }
  
  return axiosPromise
    .then(response => {
      if (process.env.NODE_ENV === 'development') {
        console.log("🚀 API Response received:", response)
        console.log("🚀 Response status:", response.status)
        console.log("🚀 Response data:", response.data)
      }
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      if (process.env.NODE_ENV === 'development') {
        console.log("🚀 API Error occurred:", err)
        console.log("🚀 Error type:", typeof err)
        console.log("🚀 Error message:", err.message)
        console.log("🚀 Error response:", err.response)
        console.log("🚀 Error request:", err.request)
      }
      
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.response?.data?.message || "An error occurred"
            break
        }
        return { error: message, status: "Error" }
      }
      return err.response?.data || err
    })
}

export const companyRegisterApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }
  return axios
    .post(`${BASEURL}${COMPANY_REGISTER}`, data, headers)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.join(", ")
            break
        }
      }
      throw message
    })
}

export const userRegisterApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }
  return axios
    .post(`${BASEURL}${USER_SIGNUP}`, data, headers)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message

      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.join(", ")
            break
        }
      }
      throw message
    })
}

export const forgotPasswordApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }

  return axios
    .post(`${BASEURL}${FORGOTPWD}${data.email}`, null, headers)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.join(", ")
            break
        }
      }
      throw message
    })
}

export const resetPasswordApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }

  return axios
    .post(`${BASEURL}/Auth/ResetPassword`, data, headers)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.join(", ")
            break
        }
      }
      return err.response.data
      // throw message;
    })
}
export const compresetPasswordApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }

  return axios
    .post(`${BASEURL}/Company/ActivateCompanyAndSetPassword`, data, headers)
    .then(response => {
      console.log(response.data.statusCode, "response")
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })

    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break

          default:
            message = err.join(", ")
            break
        }
      }
      return err.response.data
      // throw message;
    })
}

export const verifyAccountApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }

  return axios
    .post(`${BASEURL}/verify_account`, data, headers)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.join(", ")
            break
        }
      }
      throw message
    })
}
export const verifyEmailAccountApi = data => {
  const headers = {
    headers: { "Content-Type": "application/json; charset=UTF-8" },
  }

  return axios
    .post(`${BASEURL}/Auth/User/Activate/token?token=${data}`, {}, headers)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err.join(", ")
            break
        }
      }
      return err.response.data
      // throw message;
    })
}
